import { render, staticRenderFns } from "./TeamRequestsList.vue?vue&type=template&id=671f6ba8&scoped=true"
import script from "./teamRequestsList.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestsList.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestsList.vue?vue&type=style&index=0&id=671f6ba8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f6ba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671f6ba8')) {
      api.createRecord('671f6ba8', component.options)
    } else {
      api.reload('671f6ba8', component.options)
    }
    module.hot.accept("./TeamRequestsList.vue?vue&type=template&id=671f6ba8&scoped=true", function () {
      api.rerender('671f6ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/manager/team-requests/team-requests-list/TeamRequestsList.vue"
export default component.exports